import { render, staticRenderFns } from "./ClassPickerAutocomplete.vue?vue&type=template&id=5afdf2ce&scoped=true&"
import script from "./ClassPickerAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ClassPickerAutocomplete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5afdf2ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!C:/Users/Dan/code/teacher-helper/teacher-helper/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
installComponents(component, {VAutocomplete})
